import { XCircle, CheckCircle, ArrowRight } from "lucide-react";
import beforeAfterImage from "@/assets/before-after-stress.png";
import creditComparisonImage from "@/assets/credit-comparison.png";
const problems = ["Llegas a EE.UU. y nadie te explica cómo funciona el crédito", "Tu score es bajo y no sabes exactamente por qué", "Te rechazan tarjetas, rentas o préstamos una y otra vez", "Terminas pagando intereses abusivos", "Empresas de \"reparación\" te cobran miles sin garantías", "Vives con miedo de equivocarte y empeorar tu crédito"];
const solutions = ["Aprendes paso a paso cómo funciona el crédito en EE.UU.", "Construyes crédito desde cero, incluso con ITIN", "Aplicás técnicas reales para subir tu score 100+ puntos", "Sabes exactamente qué hacer antes de solicitar tarjetas o préstamos", "Negocias tasas más bajas y mejores condiciones", "Todo explicado en español, sin tecnicismos ni estafas"];
const ProblemSection = () => {
  return <section className="relative overflow-hidden section-padding gradient-hero">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      <div className="container-centered relative z-10">
        <div className="mx-auto max-w-5xl">
          {/* Section Header */}
          <div className="mb-12 text-center">
            <span className="inline-block rounded-full bg-primary/10 px-4 py-2 text-primary font-bold text-xl">
              ⚠️ Si estás aquí, probablemente te identificas con esto:

            </span>
            <h2 className="mt-4 font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
              Por qué trabajar duro en EE.UU. no es suficiente{" "}
              <span className="text-primary">si tu crédito está en contra tuya</span>
            </h2>
          </div>

          {/* Before/After Image */}
          <div className="mb-12 flex justify-center">
            <img alt="Antes y después: del estrés financiero a la tranquilidad" className="w-full max-w-3xl rounded-2xl shadow-2xl border-2 border-primary/20" width="606" height="606" loading="lazy" decoding="async" src="/lovable-uploads/f3cfe23d-286d-4981-8051-127ccd98b09f.webp" />
          </div>

          {/* Two Column Layout */}
          <div className="grid gap-8 md:grid-cols-2">
            {/* Problems Column */}
            <div className="rounded-2xl bg-card p-6 sm:p-8 border border-destructive/30 shadow-lg">
              <h3 className="mb-6 flex items-center gap-2 font-display text-lg font-bold text-destructive">
                <XCircle className="h-6 w-6" />
                Sin Este Sistema...
              </h3>
              <ul className="space-y-4">
                {problems.map((problem, index) => <li key={index} className="flex items-start gap-3 text-lime-300">
                    <XCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-destructive" />
                    <span className="font-bold text-green-50">{problem}</span>
                  </li>)}
              </ul>
            </div>

            {/* Solutions Column */}
            <div className="rounded-2xl bg-card p-6 sm:p-8 border border-primary/30 shadow-lg">
              <h3 className="mb-6 flex items-center gap-2 font-display font-bold text-primary text-center text-xl">
                <CheckCircle className="h-6 w-6" />
                Con El Código del Crédito Perfecto...
              </h3>
              <ul className="space-y-4">
                {solutions.map((solution, index) => <li key={index} className="flex items-start gap-3">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary" />
                    <span className="font-bold text-secondary-foreground">{solution}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Credit Comparison Image */}
          <div className="mt-12 flex justify-center">
            
          </div>

          {/* Transition Arrow */}
          <div className="mt-12 flex justify-center">
            <div className="flex flex-col items-center gap-2">
              <ArrowRight className="h-8 w-8 rotate-90 text-primary" />
              <span className="font-display font-bold text-primary text-xl text-center">La solución no es magia.
Es un sistema claro, legal y probado.</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ProblemSection;